module.exports = __webpack_public_path__ + "d7139788deb7840ced7ab505c064ba0f.png";